// Sticky-note shortcut preferences — per-device, localStorage-backed.
// Two parts: whether the shortcut is visible at all, and which of the
// two visual variants is used when it is.

export type StickyNoteVariant = 'floating' | 'stack';

export interface StickyNotePrefs {
  enabled: boolean;
  variant: StickyNoteVariant;
}

export const DEFAULT_STICKY_NOTE_PREFS: StickyNotePrefs = {
  enabled: true,
  variant: 'floating',
};

const ENABLED_KEY = 'stacked.sticky.enabled';
const VARIANT_KEY = 'stacked.sticky.variant';

const VALID_VARIANTS: StickyNoteVariant[] = ['floating', 'stack'];

export function readStickyNotePrefs(): StickyNotePrefs {
  if (typeof window === 'undefined') return DEFAULT_STICKY_NOTE_PREFS;
  let enabled = DEFAULT_STICKY_NOTE_PREFS.enabled;
  let variant = DEFAULT_STICKY_NOTE_PREFS.variant;
  try {
    const rawEnabled = window.localStorage.getItem(ENABLED_KEY);
    if (rawEnabled === 'true') enabled = true;
    else if (rawEnabled === 'false') enabled = false;
    const rawVariant = window.localStorage.getItem(VARIANT_KEY);
    if (rawVariant && (VALID_VARIANTS as string[]).includes(rawVariant)) {
      variant = rawVariant as StickyNoteVariant;
    }
  } catch {
    // best-effort
  }
  return { enabled, variant };
}

export function writeStickyNoteEnabled(value: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(ENABLED_KEY, String(value));
  } catch {
    // best-effort
  }
}

export function writeStickyNoteVariant(value: StickyNoteVariant): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(VARIANT_KEY, value);
  } catch {
    // best-effort
  }
}
